import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get, find, compact, isEqual } from 'lodash'
import classes from '../ProductModal.scss'
import { apiFetch, formatMoney } from 'helpers/utilities'
import { orderActions, userActions } from 'redux/actionCreators'
import moment from 'moment'

const mapStateToProps = (state) => {
  const productKey = get(state, 'app.modalProductKey') || ''
  const productCode = productKey.slice(0, -2)
  const unitId = productKey.slice(-1)
  return {
    visible: get(state, 'app.modalVisible'),
    productCode,
    unitId,
    amount: get(state, 'app.modalProductAmount'),
    closeHidden: get(state, 'app.modalCloseHidden') || false,
    userClass: get(state, 'user.me.userClass') || 0,
    cartProductMap: get(state, 'order.cartProductMap') || {},
    userId: get(state, 'user.me.userId')
  }
}

const mapDispatchToProps = (dispatch) => ({
  closeProductModal: () => {
    dispatch({ type: 'PRODUCT_MODAL_CLOSE' })
  },
  changeProductKey: (productKey, amount) =>
    dispatch({ type: 'PRODUCT_MODAL_KEY_CHANGED', productKey, amount }),
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload)),
  attemptAddToWishlist: (productCode) =>
    dispatch(userActions.attemptAddToWishlist({ productCode })),
  attemptRemoveFromWishlist: (productCode) =>
    dispatch(userActions.attemptRemoveFromWishlist({ productCode }))
})

@connect(mapStateToProps, mapDispatchToProps)
class ProductModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentIndex: 0,
      amount: 0,
      selectedUnitId: props.unitId
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && (this.props.productCode !== nextProps.productCode || this.props.unitId !== nextProps.unitId || !isEqual(this.props.cartProductMap, nextProps.cartProductMap))) {
      const { productCode, unitId } = nextProps
      Promise.all([
        apiFetch({ endpoint: `/products/${productCode}` }),
        apiFetch({ endpoint: `/products/${productCode}/recommendations` }),
        apiFetch({ endpoint: `/product-images/${productCode}` })
      ])
        .then(([product, recommendations, imagePaths]) => {
          this.setState({
            product,
            recommendations,
            imagePaths: imagePaths.map(({ imagePath }) => imagePath),
            selectedUnitId: unitId,
            amount: get(nextProps, ['cartProductMap', `${productCode}-${unitId || 0}`, 'amount']) || 0
          })
        })
        .catch(error => {
          console.error(error)
        })
    }
  }

  _price = (unit) =>
    unit[['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][this.props.userClass]]

  _onAddToCart = () => {
    const selectedUnit = find(get(this.state, 'product.units') || [], unit => `${unit.unitId}` === `${this.state.selectedUnitId}`)
    this.props.attemptAddToCart({
      productCode: get(this.state, 'product.productCode'),
      amount: this.state.amount,
      price: this._price(selectedUnit),
      unitId: this.state.selectedUnitId
    })
  }

  _onRemoveFromCart = () => {
    const selectedUnit = find(get(this.state, 'product.units') || [], unit => `${unit.unitId}` === `${this.state.selectedUnitId}`)
    this.setState({ amount: 0 }, () =>
      this.props.attemptAddToCart({
        productCode: get(this.state, 'product.productCode'),
        amount: 0,
        price: this._price(selectedUnit),
        unitId: this.state.selectedUnitId
      })
    )
  }

  _onToggleWishlist = () => {
    const productCode = get(this.state, 'product.productCode')
    const exists = Boolean(get(this.state, 'product.userId'))

    this.setState({ toggling: true }, () => {
      if (exists) {
        this.props.attemptRemoveFromWishlist(productCode)
        this.setState({ toggling: false, product: { ...this.state.product, userId: null } })
      } else {
        this.props.attemptAddToWishlist(productCode)
        this.setState({ toggling: false, product: { ...this.state.product, userId: this.props.userId } })
      }
    })
  }

  _onPrev = () => {
    const imagePaths = compact([get(this.state.product, 'imagePath')].concat(this.state.imagePaths))
    this.setState({
      currentIndex: (this.state.currentIndex + imagePaths.length - 1) % imagePaths.length
    })
  }

  _onNext = () => {
    const imagePaths = compact([get(this.state.product, 'imagePath')].concat(this.state.imagePaths))
    this.setState({
      currentIndex: (this.state.currentIndex + imagePaths.length + 1) % imagePaths.length
    })
  }

  render() {
    const { visible, closeProductModal, cartProductMap } = this.props
    if (!visible) return null

    const product = this.state.product || {}
    const smallestUnit = get(find(product.units || [], unit => unit.perUnit === 1), 'unit')
    const imagePaths = compact([product.imagePath].concat(this.state.imagePaths))
    const currentImagePath = imagePaths[this.state.currentIndex]

    const selectedUnit = find(product.units, unit => `${unit.unitId}` === this.state.selectedUnitId)
    const stockAmount = selectedUnit
      ? Math.floor(product.stockAmount / selectedUnit.perUnit)
      : product.stockAmount

    return (
      <section className={classes.productOverlay} onClick={closeProductModal}>
        <div className={classes.modal} onClick={e => e.stopPropagation()}>
          {!this.props.closeHidden && (
            <div className={classes.btnClose} onClick={closeProductModal}>
              <img src='/images/icon-close.png' width='40' height='40' alt='icon-close' />
            </div>
          )}
          <div className={classes.productName}>{product.productName}</div>
          <div className={classes.row}>
            <div className={classes.colLeft}>Generic Name</div>
            <div className={classes.colRight}>: {product.genericName || '-'}</div>
          </div>
          <div className={classes.row}>
            <div className={classes.colLeft}>บริษัทผู้จัดจำหน่าย</div>
            <div className={classes.colRight}>: {product.companyName}</div>
          </div>
          <div className={classes.row}>
            <div className={classes.colLeft}>รหัสสินค้า</div>
            <div className={classes.colRight}>: {product.productCode}</div>
          </div>
          {selectedUnit && selectedUnit.expDate && (
            <div className={classes.row}>
              <div className={classes.colLeft}>
                <b>วันหมดอายุ</b>
              </div>
              <div className={classes.colRight}>
                {moment(selectedUnit.expDate, 'YYYY-MM-DD').diff(moment(), 'month') >= 12
                  ? <b>: รับประกันอายุสินค้าเกิน 12 เดือน</b>
                  : <b>: {moment(selectedUnit.expDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>}
              </div>
            </div>
          )}
          {Boolean(product.remark) && (
            <div className={`${classes.row} ${classes.remark}`}>หมายเหตุ: {product.remark}</div>
          )}
          <div className={`${classes.row} ${classes.unitSelector}`}>
            <div className={classes.unitHead}>หน่วย</div>
            {(product.units || [])
              .filter(data => parseFloat(this._price(data), 10) > 0)
              .map(({ unit, unitId, perUnit, ...rest }) => {
                const isActive = `${unitId}` === `${this.state.selectedUnitId}`
                const newAmount = isActive
                  ? this.state.amount
                  : get(this.props, ['cartProductMap', `${product.productCode}-${unitId || 0}`, 'amount']) || 0
                return (
                  <div key={unitId}
                    className={`${classes.unitItem} ${isActive && classes.active}`}
                    onClick={() => this.setState({
                      selectedUnitId: unitId,
                      amount: newAmount
                    }, () => this.props.changeProductKey(`${product.productCode}-${unitId}`, newAmount))}>
                    <div className={classes.unitTitle}>{unit}</div>
                    <div className={classes.unitPrice}>{formatMoney(this._price(rest))} บาท</div>
                    <div className={classes.perUnit}>({formatMoney(this._price(rest) / (perUnit || 1))} บาท/{smallestUnit})</div>
                  </div>

                )
              })}
          </div>
          <div style={{ position: 'relative' }}>
            {imagePaths.length > 1 &&
              <img
                alt='icon-arrow-left'
                className={`${classes.arrow} ${classes.left}`}
                onClick={this._onPrev}
                src='/images/icon-arrow-left.png' />}
            <img className={classes.productImage} src={currentImagePath} role='presentation' />
            <div className={classes.watermarkWrapper}>
              {Boolean(product.freeDelivery) && <img className={classes.freeDelivery} src='/images/icon-free-shipping.svg' alt='Free Delivery' />}
              <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
            </div>
            {imagePaths.length > 1 &&
              <img
                alt='icon-arrow-right'
                className={`${classes.arrow} ${classes.right}`}
                onClick={this._onNext}
                src='/images/icon-arrow-right.png' />}
          </div>
          {product.outOfStock ? (
            <div className={classes.productAmount}>
              <div className='strike-through'>สินค้าหมดชั่วคราว</div>
              {Boolean(this.state.amount) && (
                <div style={{ marginLeft: 0 }} className={classes.btnCart} onClick={this._onRemoveFromCart}>
                  <img
                    style={{ filter: 'brightness(0) invert(1)' }}
                    src='/images/icon-bin-orange.png'
                    alt='icon-bin' width='18' height='25' />
                  <span>นำออกจากรายการ</span>
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className={classes.stockAmount}>
                <strong>คลัง: </strong>
                <span>{stockAmount}</span>
              </div>
              <div className={classes.productAmount}>
                <span>จำนวน</span>
                <input
                  className={get(cartProductMap, [`${product.productCode}-${this.state.selectedUnitId}`, 'amount']) && classes.active}
                  type='number'
                  pattern='[0-9]*'
                  value={this.state.amount}
                  onChange={e => {
                    let _num = e.target.value
                    if (_num && isNaN(_num)) return
                    _num = _num ? parseInt(_num, 10) : 0
                    this.setState({ amount: `${Math.min(_num, stockAmount)}` })
                  }} />
                <span className={classes.stockAmount}></span>
                <div className={classes.btnCart} onClick={this._onAddToCart}>
                  <img src='/images/icon-cart-white.png' alt='icon-cart' width='16' height='15' />
                  <span>ใส่ตะกร้า</span>
                </div>
              </div>
            </div>
          )}
          <div
            className={`${classes.btnWishlist} ${product.userId && classes.added}`}
            onClick={this._onToggleWishlist}>
            <span>{product.userId ? '-' : '+'} WISHLIST</span>
          </div>
          {Boolean(product.description) && (
            <div className={classes.row} style={{ marginTop: 20 }}>
              <div className={classes.colLeft}>ข้อบ่งใช้</div>
              <div className={classes.colRight}
                style={{ height: 100, overflow: 'auto' }}>
                <span>: {product.description}</span>
              </div>
            </div>
          )}
        </div>
      </section>
    )
  }
}

export default ProductModal



// WEBPACK FOOTER //
// ./src/components/products/ProductModal.js